export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow p-8 md:p-12">
        <header className="mb-8 border-b pb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">개인정보 처리방침</h1>
          <p className="text-sm text-gray-500">
            주식회사 빌드스케일(이하 &ldquo;회사&rdquo;)는 「개인정보 보호법」 등 관련 법령을 준수하며, 정보주체의 개인정보를 보호하고
            관련 고충을 신속하고 원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. 본 방침은 회사가
            제공하는 Logistic ERP 웹 서비스 및 <strong>Logistic Driver(기사용) 모바일 애플리케이션</strong>에 모두 적용됩니다.
          </p>
          <p className="text-xs text-gray-400 mt-2">시행일자: 2026년 1월 1일</p>
        </header>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제1조 (개인정보의 처리 목적)</h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            회사는 다음의 목적을 위하여 개인정보를 처리하며, 처리한 개인정보는 다음의 목적 이외의 용도로는 이용하지 않습니다.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
            <li>물류/운송 관리 서비스 제공 및 운영 (웹·모바일)</li>
            <li>회원제 서비스 이용에 따른 본인 확인 및 인증</li>
            <li>거래처·기사·차량 등 기준정보 관리</li>
            <li>주문·배차·정산 등 업무 처리 및 관련 통계</li>
            <li>기사용 앱의 운송 진행 관리 (배차 확인, 송장 등록, 운송 완료 처리)</li>
            <li>운송 중 차량 위치 정보 수집을 통한 실시간 관제</li>
            <li>새로운 배차 발생 시 기사 단말기로의 푸시 알림 전송</li>
            <li>서비스 부정이용 방지 및 비인가 사용 방지</li>
            <li>고객 문의 응대 및 민원 처리</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제2조 (처리하는 개인정보 항목)</h2>
          <h3 className="font-semibold text-gray-800 mt-3 mb-1">1) 웹 서비스 (관리자/화주)</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
            <li>필수항목: 아이디, 비밀번호, 성명, 연락처, 이메일, 사업자등록번호, 회사명</li>
            <li>선택항목: 직책, 부서, 주소</li>
            <li>자동수집항목: 접속 IP, 쿠키, 서비스 이용 기록, 접속 로그</li>
          </ul>
          <h3 className="font-semibold text-gray-800 mt-4 mb-1">2) 모바일 앱 (Logistic Driver / 기사용)</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
            <li>필수항목: 기사 코드(아이디), 비밀번호, 성명, 연락처, 차량번호</li>
            <li>
              <strong>위치정보</strong>: GPS 좌표(위도/경도). 운송 진행 중에 한해 약 30초 간격으로 수집되며, 포그라운드
              서비스(Foreground Service)로 동작하여 사용자에게 알림바를 통해 수집 사실이 항상 표시됩니다.
            </li>
            <li>
              <strong>사진/이미지</strong>: 사용자가 직접 선택하거나 카메라로 촬영한 송장 이미지(상차/하차 송장). 카메라 및
              사진 라이브러리 접근은 사용자의 명시적 권한 동의 후에만 이루어집니다.
            </li>
            <li>
              <strong>푸시 알림 토큰</strong>: Firebase Cloud Messaging(FCM)에서 발급되는 단말기 식별용 토큰
            </li>
            <li>
              <strong>단말기 정보</strong>: OS 버전, 기기 모델명, 앱 버전 (장애 진단 및 호환성 확인 목적)
            </li>
            <li>
              <strong>일정 정보</strong>: 기사가 앱에 등록한 운송 일정(일자, 제목, 메모 등)
            </li>
            <li>자동수집항목: 접속 IP, 서비스 이용 기록, 오류 로그</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제3조 (위치정보의 수집·이용)</h2>
          <div className="bg-blue-50 border border-blue-200 rounded p-4 text-gray-700 space-y-2">
            <p>
              <strong>1. 수집 목적:</strong> 운송 중인 차량의 실시간 위치를 관제 시스템에 표시하여 화주 및 관리자가 배송
              현황을 파악할 수 있도록 하기 위함입니다.
            </p>
            <p>
              <strong>2. 수집 시점:</strong> 사용자가 앱에서 위치 수집을 ON으로 설정하고 운송을 시작한 시점부터, 운송이
              종료되거나 위치 수집을 OFF로 변경하기 전까지만 수집합니다.
            </p>
            <p>
              <strong>3. 수집 방식:</strong> Android 포그라운드 서비스로 동작하며, 위치 수집 중에는 알림바에 &ldquo;위치
              수집 중&rdquo; 알림이 항상 노출됩니다. 백그라운드에서 사용자가 인지하지 못하는 위치 수집은 수행하지 않습니다.
            </p>
            <p>
              <strong>4. 권한 거부:</strong> 위치 권한은 언제든 단말기 설정 또는 앱 내 &ldquo;내 정보 → 위치 수집&rdquo;에서
              거부/철회할 수 있으며, 거부 시 관제 기능을 제외한 다른 기능은 정상 사용 가능합니다.
            </p>
            <p>
              <strong>5. 보유기간:</strong> 위치정보는 운송 이력 관리 목적으로 수집일로부터 1년간 보관 후 파기합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제4조 (카메라·사진 권한의 이용)</h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            기사용 모바일 앱은 송장 이미지를 등록하기 위해 카메라 및 사진 라이브러리에 접근합니다. 다음과 같이 처리됩니다.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
            <li>사용자가 송장 등록 화면에서 직접 촬영하거나 갤러리에서 선택한 이미지만 업로드됩니다.</li>
            <li>앱이 임의로 사진 라이브러리 전체를 스캔하거나 업로드하지 않습니다.</li>
            <li>업로드된 송장 이미지는 운송 증빙 자료로서 회사 서버에 저장됩니다.</li>
            <li>권한은 단말기 설정에서 언제든 철회할 수 있습니다.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제5조 (푸시 알림)</h2>
          <p className="text-gray-700 leading-relaxed">
            새로운 배차가 발생한 경우 등에 한해 Firebase Cloud Messaging(FCM)을 통해 푸시 알림을 발송하며, 이를 위해 단말기
            푸시 토큰을 수집·저장합니다. 푸시 알림은 앱 내 &ldquo;내 정보 → 푸시 알림&rdquo; 또는 단말기 설정에서 ON/OFF
            설정 가능합니다.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제6조 (개인정보의 처리 및 보유기간)</h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 보유·이용기간 내에서
            개인정보를 처리·보유합니다.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
            <li>회원정보(기사 정보 포함): 회원 탈퇴 시까지</li>
            <li>운송 기록(거래 정보 포함): 「화물자동차 운수사업법」 등 관련 법령에 따라 5년</li>
            <li>송장 이미지: 운송 완료일로부터 5년</li>
            <li>위치정보: 수집일로부터 1년</li>
            <li>일정 정보: 회원 탈퇴 또는 삭제 요청 시까지</li>
            <li>접속 로그: 「통신비밀보호법」에 따라 3개월</li>
            <li>푸시 토큰: 로그아웃 또는 토큰 갱신 시까지</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제7조 (개인정보의 제3자 제공)</h2>
          <p className="text-gray-700 leading-relaxed">
            회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의,
            법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
            다만 운송 계약 이행을 위해 화주(고객사)에게 해당 운송 건과 관련된 기사 성명, 연락처, 차량번호, 운송 위치 등을
            제공할 수 있습니다.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제8조 (개인정보 처리의 위탁)</h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            회사는 원활한 서비스 제공을 위하여 다음과 같이 개인정보 처리 업무를 외부에 위탁할 수 있습니다.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
            <li>
              <strong>Google LLC (Firebase Cloud Messaging)</strong>: 푸시 알림 발송을 위한 토큰 처리
            </li>
            <li>
              <strong>Google LLC (Google Play Services / Location)</strong>: Android 단말기 위치 정보 수집 보조
            </li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-2">
            회사는 위탁계약 체결 시 개인정보 보호 관련 법령의 준수, 위탁업무의 목적 외 처리 금지, 기술적·관리적 보호조치 등을
            계약서에 명시하고 수탁자가 개인정보를 안전하게 처리하는지를 감독합니다.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제9조 (정보주체의 권리·의무 및 행사방법)</h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
            <li>개인정보 열람 요구</li>
            <li>오류 등이 있을 경우 정정 요구</li>
            <li>삭제 요구</li>
            <li>처리정지 요구</li>
            <li>앱 권한(위치, 카메라, 사진, 푸시 알림 등) 동의 철회</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-2">
            권리 행사는 본 방침 제11조의 개인정보 보호책임자에게 서면, 전화 또는 이메일을 통해 요청할 수 있으며, 회사는 지체
            없이 조치하겠습니다.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제10조 (개인정보의 파기 및 안전성 확보 조치)</h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            회사는 개인정보 보유기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를
            파기합니다. 전자적 파일 형태는 복구·재생할 수 없도록 영구 삭제하며, 종이 문서는 분쇄 또는 소각합니다.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
            <li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육</li>
            <li>기술적 조치: 개인정보처리시스템 접근권한 관리, 비밀번호 암호화 저장, JWT 기반 인증, HTTPS 등 전송 구간 보호</li>
            <li>물리적 조치: 전산실, 자료보관실 등의 접근 통제</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제11조 (개인정보 보호책임자)</h2>
          <div className="bg-gray-50 border border-gray-200 rounded p-4 text-gray-700">
            <p>· 개인정보 보호책임자: 주식회사 빌드스케일 대표</p>
            <p>· 연락처: jungi@buildscale.net</p>
            <p className="text-sm text-gray-500 mt-2">
              정보주체는 회사의 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을
              개인정보 보호책임자에게 문의할 수 있습니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제12조 (계정 및 데이터 삭제 요청)</h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            모바일 앱(Logistic Driver) 이용자는 본인 계정 및 관련 개인정보의 삭제를 아래와 같이 요청할 수 있습니다.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
            <li>
              <strong>요청 방법</strong>: 개인정보 보호책임자 이메일(jungi@buildscale.net)로 &ldquo;계정 삭제 요청&rdquo;을
              제목으로, 본문에 가입 시 사용한 전화번호를 기재하여 발송 (또는 계정 삭제 요청 페이지{" "}
              <a href="/account-deletion.html" className="text-blue-600 underline">
                https://jungam.co.kr/account-deletion.html
              </a>{" "}
              이용)
            </li>
            <li>
              <strong>처리 기한</strong>: 영업일 기준 7일 이내
            </li>
            <li>
              <strong>삭제되는 데이터</strong>: 회원 정보(이름, 전화번호), 위치 정보, 송장 이미지, 일정 정보, 푸시 알림 토큰
            </li>
            <li>
              <strong>보관되는 데이터</strong>: 운송 기록은 「화물자동차 운수사업법」에 따라 5년간 보관 후 파기
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제13조 (권익침해 구제방법)</h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의할 수 있습니다.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2">
            <li>개인정보분쟁조정위원회: (국번없이) 1833-6972 / www.kopico.go.kr</li>
            <li>개인정보침해신고센터: (국번없이) 118 / privacy.kisa.or.kr</li>
            <li>대검찰청: (국번없이) 1301 / www.spo.go.kr</li>
            <li>경찰청: (국번없이) 182 / ecrm.cyber.go.kr</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">제14조 (개인정보 처리방침의 변경)</h2>
          <p className="text-gray-700 leading-relaxed">
            본 개인정보 처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는
            변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
          </p>
        </section>

        <footer className="mt-10 pt-6 border-t text-center text-sm text-gray-500">
          주식회사 빌드스케일 · Logistic ERP System &amp; Logistic Driver App
        </footer>
      </div>
    </div>
  );
}
